module.exports = __webpack_public_path__ + "img/perks_H Dedicated Rep.b18ee843.jpg";